/**
 * Sitenin tek doğruluk kaynağı olan adres bilgileri.
 * Domain değişirse SADECE burası ve scripts/generate-sitemap.mjs güncellenir.
 */
export const SITE_URL = 'https://ardicvet.com'

export const SITE_NAME = 'Ardıç Veteriner Kliniği'

/** Başlık ekinde kullanılır; tam ad <title>'ı 60 karakterin üstüne çıkarıyor. */
export const SITE_SHORT_NAME = 'Ardıç Veteriner'

/** Google başlıkları ~60 karakterde kesiyor. */
export const TITLE_MAX = 60

/** Göreli yolu mutlak URL'e çevirir. absUrl('/about') -> 'https://ardicvet.com/about' */
export const absUrl = (path = '/'): string => {
  if (path.startsWith('http')) return path
  return `${SITE_URL}${path.startsWith('/') ? path : `/${path}`}`
}

/**
 * Google İşletme Profili — yorumların tamamı ve güncel puan burada.
 * Kendi sitemizde puan ortalaması göstermiyoruz; Google'ın politikası gereği
 * işletmenin kendi sitesindeki kendi yorumları yıldız zengin sonucuna uygun değil.
 */
export const GOOGLE_REVIEWS_URL =
  'https://www.google.com/search?q=Ard%C4%B1%C3%A7+Veteriner+Klini%C4%9Fi+Karak%C3%B6pr%C3%BC+%C5%9Eanl%C4%B1urfa'
